import camelCase from 'lodash/camelCase';
import React, { useEffect, useState } from 'react';

import {
  ContentstackPreviewProps,
  WithContentstackPreviewProps,
} from './models';
import { onEntryChange, Stack } from './Stack';

const ContentstackPreview = (
  props: WithContentstackPreviewProps & ContentstackPreviewProps
) => {
  const {
    WrappedComponent,
    data,
    pageContext: { locale, uid },
    contentType,
  } = props;

  const [currentData, setCurrentData] = useState(data);

  useEffect(() => {
    const updateData = async () => {
      const query = Stack.ContentType(contentType).Entry(uid).language(locale);

      // based on getGatsbyDataFormat: https://github.com/contentstack/live-preview-sdk/blob/0da5d451f668694ad93b39b45e46d45a54e52826/src/contentstack-live-preview-HOC.ts#L102
      const fetchedData = await query.toJSON().fetch();
      const dataTitle = camelCase(`contentstack_${contentType}`);
      const newData = { [dataTitle]: fetchedData };

      setCurrentData({ ...data, newData });
    };

    if (process.env.GATSBY_CONTENTSTACK_LIVE_PREVIEW === 'true')
      onEntryChange(updateData);
  }, [data, uid, locale, contentType]);

  return <WrappedComponent {...{ ...props, data: currentData }} />;
};

export default ContentstackPreview;
